function getDisplayNumber(value: number) {
  return value >= 10 ? (value % 100).toString() : `0${value}`
}

export function getDisplayDate(value?: Date) {
  return value
    ? `${getDisplayNumber(value.getMonth() + 1)}/${getDisplayNumber(value.getDate())}/${getDisplayNumber(
        value.getFullYear()
      )} ${getDisplayNumber(value.getHours())}:${getDisplayNumber(value.getMinutes())}:${getDisplayNumber(
        value.getSeconds()
      )}`
    : '-'
}
